import Icons from 'appearance/icons'
import {React} from 'common'
import Table from 'components/Display/Table'
import {Page, PageContent} from 'components/Page'
import {useDeleteClientMutation, useGetClientsQuery, useI18n} from 'store/Store'
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined'
import Snackbar from 'components/Display/Snackbar'
import {useDeviceDetect} from 'services/hooks'
import useClientsScreen from 'logic/screens/useClientsScreen'
import MaxQuotaDialog from './Client/MaxQuotaDialog'

const Clients = () => {
    const {isMobile} = useDeviceDetect()
    const {i18n} = useI18n()

    const {
        generateLink,
        snackbarText,
        closeSnackbar,
        loading,
        quotaError,
        setQoutaError,
    } = useClientsScreen()

    return (
        <Page>
            <PageContent
                style={{
                    padding: `48px ${isMobile ? 20 : 48}px`,
                }}>
                <Table
                    // allowDelete
                    periodicRefresh={10000}
                    useSearch={false}
                    itemName="client"
                    itemKey="PlannerClientKey"
                    useGetQuery={useGetClientsQuery}
                    useDeleteMutation={useDeleteClientMutation}
                    tableTitleIcon={Icons.Clients}
                    additionalActions={[
                        {
                            icon: () => SmsOutlinedIcon,
                            action: (clientId) => {
                                console.log('sending...', clientId)
                                generateLink({
                                    PlannerClientKey: clientId,
                                    sendSms: true,
                                })
                            },
                            isLoading: (clientId) => loading[clientId],
                        },
                    ]}
                    additionalActionsTitle={i18n.t('clients.sendRequest')}
                />
            </PageContent>
            <Snackbar
                open={!!snackbarText}
                onClose={closeSnackbar}
                message={snackbarText}
            />
            <MaxQuotaDialog
                quotaError={quotaError}
                setQoutaError={setQoutaError}
            />
        </Page>
    )
}

export default Clients
